import { EHelpCenterType } from '@portals/help-center-core';

export enum EAnalyticsEvents {
  ENTRY_DRAWER_BUTTON_CLICK = 'Supplier_HelpCenter_EntryButton_T',
  MAIN_PAGE_VIEW = 'Supplier_HelpCenter_MainPage_V',
  MAIN_PAGE_SECTION_CLICK = 'Supplier_HelpCenter_MainPage_Section_T',
  SECTION_VIEW = 'Supplier_HelpCenter_Section_V',
  SUBSECTION_CLICK = 'Supplier_HelpCenter_Section_Subsection_T',
  FAQ_CLICK = 'Supplier_HelpCenter_Subsection_FAQ_T',
  SUBSECTION_VIEW = 'Supplier_HelpCenter_Subsection_V',
  ARTICLE_CLICK_FROM_CATEGORY = 'Supplier_HelpCenter_Subsection_Article_T',
  ARTICLE_CLICK_FROM_ADVICE_LIST = 'Supplier_HelpCenter_SuggestionList_Article_T',
  ARTICLE_VIEW = 'Supplier_HelpCenter_Article_V',
  IN_ARTICLE_ON_LINK_CLICK = 'Supplier_HelpCenter_Article_Link_T',
  IN_ARTICLE_ON_HEADER_CONTENTS_CLICK = 'Supplier_HelpCenter_Article_Contents_Apl',
  IN_ARTICLE_MORE_THAN_HALF_VIEWED = 'Supplier_HelpCenter_Article_Block_V',
  IN_ARTICLE_END_VIEWED = 'Supplier_HelpCenter_Article_Scroll',
  IN_ARTICLE_CLICK_RECOMMENDED_LINK = 'Supplier_HelpCenter_Article_Recommendation_Apl',
  ARTICLE_RATE_CLICK = 'Supplier_HelpCenter_Article_Rate_T',
  ARTICLE_RATE_SEND_CLICK = 'Supplier_HelpCenter_Article_Rate_Send',
  ARTICLE_RATE_CANCEL_CLICK = 'Supplier_HelpCenter_Article_Rate_Cancel',
  BACK_BUTTON_CLICK = 'Supplier_HelpCenter_BackButton_T',
  IN_DRAWER_ON_HELP_CENTER_LINK_CLICK = 'Supplier_HelpCenter_HelpCenterLink_T',
  HELP_CENTER_PAGE_CLOSE = 'Supplier_HelpCenter_Close',
  ARTICLE_PRINT_CLICK = 'Supplier_HelpCenter_Article_SavePDF',
  SEARCH_START_TYPING = 'Supplier_HelpCenter_Search_StartTyping',
  SEARCH_CLEAR = 'Supplier_HelpCenter_Search_Clear_T',
  SEARCH_SUBMIT = 'Supplier_HelpCenter_Search_T',
  SEARCH_VIEW_RESULT = 'Supplier_HelpCenter_Search_Result_S',
  ML_SEARCH_VIEW_RESULT = 'Supplier_HelpCenter_Search_Result_ML_S',
  ML_SEARCH_CLICK_LIKE = 'Supplier_HelpCenter_Search_Result_ML_Like_T',
  ML_SEARCH_CLICK_DISLIKE = 'Supplier_HelpCenter_Search_Result_ML_Dislike_T',
  ML_SEARCH_CLICK_LINK = 'Supplier_HelpCenter_Search_Result_ML_T',
  SEARCH_BACK_BUTTON_CLICK = 'Supplier_HelpCenter_Search_BackButton_T',
  SEARCH_ITEM_CLICK = 'Supplier_HelpCenter_Search_Result_T',
  TELEGRAM_UTM_SOURCE = 'Supplier_HelpCenter_ThroughTelegramLink_Entry',
  CATEGORIES_FOOTER_VIEW = 'Supplier_HelpCenter_Footer_S',
  CATEGORIES_FOOTER_CLICK = 'Supplier_HelpCenter_Footer_T',
  COOKIE_BANNER_CLICK = 'Supplier_CookieBanner_Ok_T',
  DRAWER_TAB_CLICK = 'Supplier_HelpCenter_Curtain_Tab_T',
  DRAWER_SUGGESTION_LIST = 'Supplier_HelpCenter_SuggestionList_V',
  DRAWER_OPEN_FAQ = 'Supplier_HelpCenter_Curtain_Question_T',
  DRAWER_FEEDBACK_RATE = 'Supplier_HelpCenter_Curtain_SectionFeedback_Rate_T',
  DRAWER_FEEDBACK_SUBMIT = 'Supplier_HelpCenter_Curtain_SectionFeedback_Send',
}

export enum EPageType {
  MAIN_PAGE = 'MainPage',
  SECTION = 'Section',
  SUBSECTION = 'Subsection',
  ARTICLE = 'Article',
  ADVICE_LIST = 'SuggestionList',
  ADVICE_LIST_ARTICLE = 'SuggestionListArticle',
  SEARCH = 'Search',
}

export type TBooleanString = 'true' | 'false';

export enum EPositionBlock {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export type TAnalyticEventParams = {
  url: string;
  name: typeof document.title;
  helpCenterType: EHelpCenterType;
  sectionName: string | null | 'by_link';
  subsectionId: string | null;
  subsectionName: string | null | 'by_link' | 'by_recommend';
  sectionId: string | null;
  questionName: string;
  idArticle: string;
  articleName: string;
  isSidebar: boolean;
  linkName: string;
  linkUrl: string;
  blockName: string;
  rate: number;
  chosenSuggests: Array<string> | string;
  textComment: string;
  isDisabled: boolean; // состояние кнопки, по которой кликает юзер
  pageType: EPageType;
  pageName: typeof document.title; // как и нейм, только для опредленных эвентов
  likesText: string;
  dislikesText: string;
  commentText: string;
  query: string; // поисковая строка
  articlesFound: number; // для результатов поиска
  tipsFound: number; // для выпадающего списка в инпуте поиска
  isEmpty: boolean; // для результатов поиска
  isEmptyTips: boolean; // для выпадающего списка в инпуте поиска
  articleNumber: number; // какая по счету была статья в выдаче
  availableLinks: string; // ссылки на статьи  в ответе ML
  requestId: string; // id результата, который вернул ML
  isForSellersML: 'true' | 'false'; // результат ML только для селлеров или доступен всем
  linkType: 'text_link' | 'source'; // тип ссылки, по которой перешел селлер в выдаче ML
  link: string; // ссылка статьи или раздела, по которой перешел пользователь в выдаче ML
  buttonName: string; // текст кнопки футера, по которой кликает пользователь
  idsArticles: Array<string> | null;
  locale: string;
  region: string;
  isAvailableOnlyByLink: boolean;
  autoSuggestion: boolean; // выбрана ли автоподсказка
  autoSuggestionNum: number; // номер автоподсказки
  idUser: number;
  idSupplier: string;
  cntArticles: number;
  idArticles: string; // список ids статей через запятую
  idFAQ: string | null;
  faqName: string;
  isArticleButtonAvail: TBooleanString;
  isVideoButtonAvail: TBooleanString;
  isRecommendBlock: TBooleanString; // есть ли в материале рекомендованные статьи
  comment: string;
  idRecArticle: string;
  nameRecArticle: string;
  idsRecommendBlock: string | 'no' | 'isLoading'; // id через запятую; isLoading - фронтовый статус
  tapPosition: EPositionBlock;
  hasAnchor: boolean;
  byAnchorLink: boolean;
};

export type TPreparedAnalyticEventParams = Record<string, string | number>;
